import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../components/common/Button";
import Text from "../../components/common/Text";
import FlexBox from "../../components/common/FlexBox";
import HR from "../../components/common/HR";
import Div from "../../components/common/Div";
import DateDisplay from "../../components/common/DateDisplay";
import { tenzero, urlbase, headers } from "../../constants/Constants";
import ViewResultsBox from "../Partials/ViewResultsBox";
import { Typography } from "@mui/material";
import MarkProgressCircle from "../Partials/MarkProgressCircle";
import IconBar from "../Partials/IconBar";

export default function ResultScreen(props) {
  const history = useHistory();
  function preventBack() {
    window.history.forward();
  }
  setTimeout(preventBack, 0);
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined ||
    props.location.state.data === undefined ||
    props.location.state.error === undefined ||
    props.location.state.test === undefined ||
    props.location.state.questions === undefined ||
    props.location.state.submission === undefined /*||
        props.location.state.submissionResults === undefined*/
  )
    history.push("/login");

  const error = props.location.state.error;
  const marks = props.location.state.data;
  const user = props.location.state.user;
  const testData = props.location.state.test;
  const grouptest = props.location.state.grouptest;
  const questions = props.location.state.questions;
  const submission = props.location.state.submission;
  const [showModal, setShowModal] = useState(false);
  const percent = (marks / questions.length) * 100;

  const content = error ? isError() : isNotError();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

    function isCloseDateInFuture(closeDate: string | null): boolean {
        if (!closeDate) return false;
        const closeDateTime = new Date(closeDate).getTime();
        const currentDateTime = new Date().getTime();
        return closeDateTime > currentDateTime;
    }

    function ContinueHandler() {
        if (!grouptest) {
            setShowModal(true);
            return;
        }

        if (isCloseDateInFuture(grouptest.close_date)) {
            history.push("/testdashboard", { user: user });
        } else {
            setShowModal(true);
        }
    }
    function ContinueButton() {
        const buttonText =
            grouptest && isCloseDateInFuture(grouptest.close_date) ? "FINISH" : "VIEW RESULTS";

        return (
            <Button
                fontSize={"1rem"}
                padding={"15px 15px"}
                width={"100%"}
                marginTop={"15px"}
                borderRadius={"5px"}
                backgroundColor={"#fbcd02"}
                color={"#00112e"}
                fontWeight={"bold"}
                textTransform={"uppercase"}
                onClick={ContinueHandler}
            >
                {buttonText}
            </Button>
        );
    }

  function isNotError() {
    return (
      <>
        {/*test name*/}
        <Div margin={tenzero}>
          <Typography
            style={{
              margin: "0px 0px 20px",
              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
              lineHeight: 1.334,
              letterSpacing: "0em",
              fontSize: "1.1rem",
              color: "rgb(251, 205, 2)",
              fontWeight: 700,
            }}
          >
            {testData.name}
          </Typography>
        </Div>
        <div
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            borderRadius: "5px",
            padding: "10px 0px",
            marginBottom: "30px",
          }}
        >
          {/*test sub details*/}
          <Div margin={tenzero}>
            <Typography
              color={"#FFFFFF"}
              style={{
                margin: "0px",
                fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                fontSize: "1rem",
                lineHeight: 1.5,
                letterSpacing: "0.00938em",
                color: "rgb(0, 17, 46)",
                fontWeight: 700,
              }}
            >
              {testData.area}
              {": "}
              {testData.module}
            </Typography>
          </Div>
        </div>

        {/*marks out of ..*/}
        <Div margin={tenzero}>
          <MarkProgressCircle
            value={percent === 0 ? 0.5 : percent}
            size={"150px"}
            thickness={3.5}
            sx={{ color: "rgb(251, 205, 2)" }}
            mark={marks}
            numQuestions={questions.length}
          />
          <Typography variant="body1" color="white" textAlign={"left"}>
            <div
              style={{
                color: "#FBCD02",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              Description:
            </div>
            {/*test grade*/}
            Grade: {testData.grade}
            <br />
            <div>
              <Typography
                variant="caption"
                component="div"
                color="white"
                sx={{ fontSize: "17px" }}
              >
                Time Taken: {localStorage.getItem("time")}
              </Typography>
            </div>
            <div style={{ color: "#FFFFFF", marginBottom: "10px" }}>
              Date: <DateDisplay date={new Date()} />
            </div>
          </Typography>
        </Div>

        {/*continue*/}
        <Div margin={tenzero}>{ContinueButton()}</Div>
        <ViewResultsBox
          display={showModal}
          handler1={() => {
            setShowModal(false)
          }}
          handler2={() => {
            history.push("/testresults", {
              user: user,
              test: testData,
              questions: questions,
              submission: submission,
              submissionResults: marks,
              grouptest: grouptest,
            });
          }}
        />
      </>
    );
  }

  function isError() {
    return (
      <>
        <Text color={"#FFFFFF"}>
          There was an error in submitting your test.
        </Text>
        <Div margin={tenzero}>{ContinueButton()}</Div>
      </>
    );
  }

  return (
    <div style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}>
      <div className="HeaderBox">
        <IconBar location={"results"} user={user} />
      </div>
      <div
        style={{
          padding: "20px",
          backgroundColor: "rgb(33, 42, 65)",
          borderRadius: "5px",
          width: "90%",
          marginTop: "15px",
          textAlign: "center",
        }}
      >
        {content}
      </div>
    </div>
  );
}
